export default function CTA() {
  return (
    <section className="section" id="contact">
      <div className="container">
        <div className="cta-card">
          <h2 className="cta-title">Have an ambitious quarter ahead?</h2>
          <p className="cta-lede">
            Tell us what you're trying to ship. We'll get back within one business day
            with a sense of fit, scope, and timing — no pitch deck required.
          </p>
          <div className="cta-actions">
            <a href="mailto:hello@northwindatlas.example" className="btn btn-primary btn-large">
              hello@northwindatlas.example
            </a>
            <a href="#services" className="btn btn-large">
              Read more first
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
